import DeleteResourceInteractor from "../../core/interactor/app/crud/DeleteResourceInteractor";
import Constants from "../common/Constants";

export default class RemoveCaseDecisionInteractor {
  private resource: DeleteResourceInteractor;

  constructor({ deleteResource }: any) {
    this.resource = deleteResource;
  }

  async execute(caseDecisionId: string) {
    return this.resource.execute(Constants.endpointBasePath, caseDecisionId);
  }
}
